import { render } from "./ColorSlider.vue?vue&type=template&id=192257fc&scoped=true"
import script from "./ColorSlider.vue?vue&type=script&lang=js"
export * from "./ColorSlider.vue?vue&type=script&lang=js"

import "./ColorSlider.vue?vue&type=style&index=0&id=192257fc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192257fc"]])

export default __exports__